import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";

const MICROSOFT_STORE_URL_BY_PACKAGE = {
  toposify_pos: "https://apps.microsoft.com/detail/xpdfmvmj8kzfln",
  toposify_statistics:
    "https://apps.microsoft.com/detail/xpfd5fqxdgpqdr?cid=PCCongratsBnr&hl=zh-CN&gl=CD",
};

const Text = styled("div")(() => ({
  marginTop: 20,
  color: "#fff",
  fontSize: 29.09,
  fontWeight: 700,
  textAlign: 'center'
}));

const downBoxItem = (theme)=> {
  return {
    [theme.breakpoints.up("xl")]: {
      transform: 'scale(1)'
    },
    [theme.breakpoints.down("xl")]: {
      transform: 'scale(1)'
    },
    [theme.breakpoints.down("lg")]: {
      transform: 'scale(0.75)'
    },
    [theme.breakpoints.down("md")]: {
      transform: 'scale(0.75)'
    },
    [theme.breakpoints.down("sm")]: {
      transform: 'scale(0.5)'
    },
    [theme.breakpoints.down("xs")]: {
      transform: 'scale(0.5)',
      '& > div': {
        marginRight: 4
      }
    },
  }
}

const BoxOuter = styled(Box)(({theme}) => ({
  display: "flex",
  flexWrap: "wrap",
  position: "relative",
  ...downBoxItem(theme)
}));

/** Google Play / App Store / Microsoft — same slot on all product pages (do not shrink). */
const STORE_BADGE_WIDTH_PX = 240;
const STORE_BADGE_HEIGHT_PX = 80;

const storeBadgeShellCss = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: STORE_BADGE_WIDTH_PX,
  height: STORE_BADGE_HEIGHT_PX,
  margin: "0 12px",
  flexShrink: 0,
  lineHeight: 0,
};

const storeBadgeImgCss = {
  width: STORE_BADGE_WIDTH_PX,
  height: STORE_BADGE_HEIGHT_PX,
  maxWidth: STORE_BADGE_WIDTH_PX,
  maxHeight: STORE_BADGE_HEIGHT_PX,
  minWidth: STORE_BADGE_WIDTH_PX,
  minHeight: STORE_BADGE_HEIGHT_PX,
  objectFit: "fill",
  objectPosition: "center",
  display: "block",
  flexShrink: 0,
};

function DownFooterWeb({
  bgColor,
  qrBgColor,
  qrcode,
  showMac = true,
  showWin = true,
  showAndriod = true,
  showDirectApk = true,
  staticWinBadge = false,
  microsoftStoreUrl: microsoftStoreUrlProp,
  urlName,
  url1,
  url2,
  u1,
  u2,
  u3,
  u4
}) {
  let [zIndex, setZIndex] = useState(-6);
  const showDownScanCode = () => {
    setZIndex(10);
  };
  const hideDownScanCode = () => {
    setZIndex(-6);
  };
  const baseUrl = 'https://download.toposfy.com/devpackage/' + urlName
  const macUrl = baseUrl + '.ipa'
  const winUrl = baseUrl + ".exe";
  const andUrl = baseUrl + '.apk'
  const microsoftStoreUrl =
    microsoftStoreUrlProp ?? MICROSOFT_STORE_URL_BY_PACKAGE[urlName];
  return (
    <BoxOuter sx={{ display: "flex" }}>
      
      {showAndriod ? (
        <a
          href={url1}
          target="downloadFile"
          download
          style={storeBadgeShellCss}
        >
          <img src={u1} style={storeBadgeImgCss} alt="" />
        </a>
      ) : null}
      {showMac ? (
        <a
          href={url2}
          target="downloadFile"
          download
          style={storeBadgeShellCss}
        >
          <img src={u2} style={storeBadgeImgCss} alt="" />
        </a>
      ) : null}
      {showWin ? (
        microsoftStoreUrl ? (
          <a
            href={microsoftStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={storeBadgeShellCss}
          >
            <img
              src={u3}
              style={storeBadgeImgCss}
              alt="Get it from Microsoft Store"
            />
          </a>
        ) : staticWinBadge ? (
          <span style={storeBadgeShellCss}>
            <img
              src={u3}
              style={storeBadgeImgCss}
              alt="Get it from Microsoft"
            />
          </span>
        ) : (
          <a href={winUrl} target="downloadFile" download style={storeBadgeShellCss}>
            <img src={u3} style={storeBadgeImgCss} alt="" />
          </a>
        )
      ) : null}
      {showDirectApk && u4 ? (
        <a href={andUrl} target="downloadFile" download style={storeBadgeShellCss}>
          <img src={u4} style={storeBadgeImgCss} alt="" />
        </a>
      ) : null}
    </BoxOuter>
  );
}
export default DownFooterWeb;
